import {
  GETUPDATECONFIGURATION_SUCCESS,
  GETUPDATECONFIGURATION_FAILED,
  RESET_GETUPDATECONFIGURATION,
  LOADING_GETUPDATECONFIGURATION,
  NETWORK_ERROR_GETUPDATECONFIGURATION,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  invalidRequest: false,
  notFound: false,
  data: {},
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETUPDATECONFIGURATION:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: "",
      };

    case GETUPDATECONFIGURATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: "",
      };

    case GETUPDATECONFIGURATION_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: "",
      };

    case NETWORK_ERROR_GETUPDATECONFIGURATION:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        data: action.payload,
        networkError: "OOPS.... Something went wrong !",
      };

    case RESET_GETUPDATECONFIGURATION:
      return (state = initialState);

    default:
      return state;
  }
};
